export enum RowId {
  tipologiaDiProcedura = 'tipologiaDiProcedura',
  debitoFinanziarioLordoEbitda = 'debitoFinanziarioLordoEbitda',
  loanToValue = 'loanToValue',
  ebitdaOneriFinanzari = 'ebitdaOneriFinanzari',
  pfnEquity = 'pfnEquity',
  cassaDebitoTotaleABreveTermine = 'cassaDebitoTotaleABreveTermine',
  debtServiceCoverageRatioDaValorizzareSoloInPresenzaDiBudget = 'debtServiceCoverageRatioDaValorizzareSoloInPresenzaDiBudget',
  ebitdaMargin = 'ebitdaMargin',
  regolaritaDeiDebitiTributariEPrevidenziali = 'regolaritaDeiDebitiTributariEPrevidenziali',
  analisiInternaSuFondatezzaSostenibilitaDelleIpotesiDelPianoETrackRecord = 'analisiInternaSuFondatezzaSostenibilitaDelleIpotesiDelPianoETrackRecord',
  pianoIndustrialeAsseveratoDaAdvisorIndustrialiFinanziariEsterni = 'pianoIndustrialeAsseveratoDaAdvisorIndustrialiFinanziariEsterni',
  scoreSettoriale = 'scoreSettoriale',
  diversificazioneGeografica = 'diversificazioneGeografica',
  diversificazioneDiBusiness = 'diversificazioneDiBusiness',
  analisiDelleFinalitaDelFinanziamentoECompatibilitaConCriteriDiErogazioneEsg = 'analisiDelleFinalitaDelFinanziamentoECompatibilitaConCriteriDiErogazioneEsg',
  verificaDellaDdSuTemiEsg = 'verificaDellaDdSuTemiEsg',
  ratingEsgSeDisponibileFornitoDaDataProvider = 'ratingEsgSeDisponibileFornitoDaDataProvider',
}
